export { GlobalStyles } from "./GlobalStyles";
